import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_y9hm5t29e6: FaireBrandEntity = {
  token: "b_y9hm5t29e6",
  type: "brand",
  name: "Feelzies",
  avatarUrl:
    "https://cdn.faire.com/fastly/ae83858fd3d907edb8dda104cb09fcbf7640ba547ad7efcfef156065be60fc63.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8cd934c20418849861f383eea6f0eca84db279a07a5e2ab6984e25dbf10f4b91.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ae83858fd3d907edb8dda104cb09fcbf7640ba547ad7efcfef156065be60fc63.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8cd934c20418849861f383eea6f0eca84db279a07a5e2ab6984e25dbf10f4b91.png",
  location: "wakefield, RI, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 18,
  isInsider: true,
  description:
    "Feelzies™ was created to solve a simple, everyday problem — kids need something to do with their hands.\n\nWhether it’s in the classroom, in the car, or at home, restless hands often turn into distraction. We designed Feelzies to give kids a safe, satisfying way to stay engaged, focused, and calm — without screens.\n\nOur signature Squishy Loop is a soft, wearable sensory bracelet that kids can stretch, squeeze, and fidget with anytime, anywhere. It’s quiet, mess-free, and designed to be worn — so it’s always within reach.\n\nParents love it because it helps kids regulate.\nKids love it because it feels amazing.\n\nAnd retailers love it because once kids try one… they want more.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:20.158Z",
    importedBy: "entity-db-cli",
  },
};
